import React from "react";
import { useState } from "react";

import NewFeedback from "../../../../components/common/NewFeedback";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";

import { Button, Card, Col, Row, Table } from "antd";
import { bulkPostVacancies } from "../../../../data/vacancies";

import "./BulkPostVacancies.css";

const BulkPostVacanciesRightbar = [];

function BulkPostVacancies() {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const columns = [
    {
      dataIndex: "name",
      render: (text) => {
        return (
          <>
            <h3>{text}</h3>
            <p>Needs Review</p>
          </>
        );
      },
    },
    {
      dataIndex: "missingInfoPercent",
      render: (text) => {
        return (
          <>
            <h3 className="red-text">{text}%</h3>
            <p className="red-text">Missing Listing Information</p>
          </>
        );
      },
    },
    {
      dataIndex: "postingStatus",
      render: (text) => {
        return (
          <>
            <h3>{text}</h3>
            <p>Posting Status</p>
          </>
        );
      },
    },
    {
      dataIndex: "action",
      render: () => <Button className="edit-btn">Edit</Button>,
    },
  ];

  return (
    <>
      <div className="bulk-post-vacancies">
        <PageHeading heading="Bulk Post Vacancies" />
        <NewFeedback
          title="Feedback for Bulk Post Vacancies Page"
          description="You can now bulk post your vacancies to the internet and your website. Let us know what you think!"
        />
        <Row>
          <Col span={24}>
            <Card title="Vacancies">
              <Row gutter={[0, 16]}>
                <Col span={24}>
                  <span>Select the vacancies you'd like to post.</span>
                </Col>
                <Col span={24}>
                  <div className="table-container">
                    <Table
                      columns={columns}
                      dataSource={bulkPostVacancies}
                      rowSelection={rowSelection}
                      pagination={false}
                    />
                  </div>
                  {/* <Row className='header-row'>
                            <Col checked={checkAll} onChange={onChangeCheckAll}><Checkbox></Checkbox></Col>
                        </Row>
                        <Row align="middle" className="data-row">
                            <Col span={3}><Checkbox checked={  checked} onChange={onChange}></Checkbox></Col>
                            <Col span={7}>
                                <h3>test 2</h3>
                                <p>Needs Review</p>
                            </Col>
                            <Col span={4}>
                            <h3 className='red-text'>test 2</h3>
                                <p className='red-text'>Needs Review</p>
                            </Col>
                            <Col span={5}>
                            <h3>test 2</h3>
                                <p>Needs Review</p>
                            </Col>
                           
                            <Col span={5}>
                            <Button className='edit-btn'>Edit</Button>
                            </Col>
                        </Row> */}
                </Col>
                <Col span={24}>
                  <Row gutter={[8, 0]}>
                    <Col>
                      <Button
                        disabled={selectedRowKeys.length < 1 ? true : false}
                      >
                        Post Vacancy to Website
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        disabled={selectedRowKeys.length < 1 ? true : false}
                      >
                        Post Vacancy to Internet
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        disabled={selectedRowKeys.length < 1 ? true : false}
                      >
                        Post Vacancy to Website and Internet
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={BulkPostVacanciesRightbar} />
      </div>
    </>
  );
}

export default BulkPostVacancies;
